import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IUserLogin, UserLogin, IUserDetails } from '../../models/user';
import { namespace } from 'vuex-class';
import { AUTHORIZATION_MODULE_NAMESPACE } from '../../store/authorization';
import { ActivityStatus } from '../../common/enums';
import { USER_MODULE_NAMESPACE } from '../../store/user/user-types.store';


const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
@Component
class Container extends Vue {

  dtPasswordMode: string;
  dtUserInfo: IUserLogin;
  app: any
  /**
   *
   */
  @AuthorizationStore.Getter signInPayload: {
    activityStatus: ActivityStatus;
    accessToken: string;
  }
  @UserStore.Getter userInfo: IUserDetails;

  constructor() {
    super();
    this.dtUserInfo = new UserLogin({ password: "", email: "" })
    this.dtPasswordMode = "password"
  }
  get lblSetting() {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/login-form').default,
    }
  }
  get agencyInfo() {
    return this.$store.getters.configuration.info
  }
  get visible(): boolean {
    return this.signInPayload.accessToken === null || this.$route.fullPath.indexOf('verifyChanges') !== -1;
  }
  mounted() {
    this.app = document.getElementById('app');
    this.app.style.overflow = "hidden";;
  }
  beforeDestroy() {
    this.app.style.overflow = "auto";
  }
}

export default Container;


// WEBPACK FOOTER //
// ./src/containers/authorization/index.ts